// Auth pages
import SignIn from "../pages/Auth/SignIn";
import SignUp from "../pages/Auth/SignUp";
import OTP from "../pages/Auth/OTP";
import ForgotPassword from "../pages/Auth/ForgotPassword";

// Dashboard without sidebar
import LotteryMega645 from "../pages/Lottery/Mega645/LotteryMega645";
import LotteryPower655 from "../pages/Lottery/Power655/LotteryPower655";
import LotteryMax4D from "../pages/Lottery/Max4D/LotteryMax4D";
import LotteryMax3D from "../pages/Lottery/Max3D/LotteryMax3D";
import LotteryMax3D_Plus from "../pages/Lottery/Max3D_Plus/LotteryMax3D_Plus";
import LotteryKeno from "../pages/Lottery/Keno/LotteryKeno";
import LotteryKenoBao from "../pages/Lottery/Keno/LotteryKenoBao";
import LotteryKenoCL from "../pages/Lottery/Keno/LotteryKenoCL";
import LotteryMax3D_Pro from "../pages/Lottery/Max3DPro/Max3DPro";
import MainAnalytic from "../pages/Analytics/MainAnalytic";
import MainResult from "../pages/Results/MainResult";
import Profile from "../pages/Profile/ProfilePage";
import LotteryLoto535 from "../pages/Lottery/Loto535/LotteryLoto535.jsx";
import Term from "../pages/Term/Term";
import PaymentHistory from "../pages/PaymentHistory/PaymentHistory";
import PaymentDetail from "../pages/PaymentHistory/PaymentDetail/PaymentDetail";
import ShoppingHistory from "../pages/ShoppingHistory/ShoppingHistory";
import ShoppingDetail from "../pages/ShoppingHistory/ShoppingDetail/ShoppingDetail";
import CompareResult from "../pages/ShoppingHistory/CompareResult/CompareResult";
import Help from "../pages/Help/Help";

import Recharge from "../pages/Wallet/Recharge";
import RechargeItems from "../pages/Wallet/RechargeItems";
import Withdrawal from "../pages/Wallet/Withdrawal";
import WithdrawalItems from "../pages/Wallet/WithdrawalItems";

import VNPAY_Return from "../pages/Wallet/VNPAY_Check";
import MegaPay_Return from "../pages/Wallet/MegaPay_Check";
import Momo_Check from "../pages/Wallet/Momo_Check";

import Notifications from "../pages/Notifications/Notifications";

import Payment from "../pages/Payment/Payment";

import Cart from "../pages/Cart/Cart";

import Home from "../pages/Home/Home";
import KTMB from "../pages/KTMB/KTMB";
import KienThiet from "../pages/Lottery/KienThiet/KienThiet";
import DT235 from "../pages/Lottery/DT235/DT235";
import DT234 from "../pages/Lottery/DT234/DT234";
import DT6x36 from "../pages/Lottery/DT6x36/DT6x36";
import DTThantai from '../pages/Lottery/DTThantai/DTThantai'
import DT123 from '../pages/Lottery/DT123/DT123'
import Guide from '../pages/Guides/Guides.jsx'
import GuideContent from '../pages/Guides/GuideContent.jsx'
import Guide235 from '../pages/Guides/Dt235'
import Guide234 from '../pages/Guides/Dt234'
import GuideThantai from '../pages/Guides/Thantai'
import Guide123 from '../pages/Guides/Dt123'
import Guide636 from '../pages/Guides/D636'
import GuideKeno from '../pages/Guides/Keno'
import GuideMega from '../pages/Guides/Mega'
import GuidePower from '../pages/Guides/Power'
import GuideMax3d from '../pages/Guides/Max3d'
import GuideMax3dPlus from '../pages/Guides/Max3dPlus'
import GuideKT from '../pages/Guides/Kienthiet'
import GuideMax3dPro from '../pages/Guides/Max3dPro'
import Live from '../pages/truc-tiep-keno/index'
import KTMN from '../pages/Lottery/KienThiet/KTMN.js'
import {
    faHome, faStore, faMoneyBill, faChartLine, faUser, faPhone, faLock, faTrophy
} from "@fortawesome/free-solid-svg-icons"

/* eslint eqeqeq: "off" */
 
const privacyRoutes = {
    path: "",
    name: "Privacy",
    children: [
        {
            path: "/auth/sign-in",
            name: "SignIn",
            component: SignIn
        },
        {
            path: "/truc-tiep-keno",
            name: "Live",
            component: Live
        },
        {
            path: "/loto535",
            name: "LotteryLoto535",
            component: LotteryLoto535
        },
        {
            path: "/huong-dan",
            name: "Guide",
            component: Guide
        },
        {
            path: "/huong-dan/keno",
            name: "GuideKeno",
            component: GuideKeno
        },
        {
            path: "/huong-dan/mega",
            name: "GuideMega",
            component: GuideMega
        },
        {
            path: "/huong-dan/power",
            name: "GuidePower",
            component: GuidePower
        },
        {
            path: "/huong-dan/max3d",
            name: "GuideMax3d",
            component: GuideMax3d
        },
        {
            path: "/huong-dan/max3dplus",
            name: "GuideMax3dP",
            component: GuideMax3dPlus
        },
        {
            path: "/huong-dan/max3dpro",
            name: "GuideMax3dpro",
            component: GuideMax3dPro
        },
        {
            path: "/huong-dan/235",
            name: "Guide235",
            component: Guide235
        },
        {
            path: "/huong-dan/234",
            name: "Guide234",
            component: Guide234
        },
        {
            path: "/huong-dan/than-tai",
            name: "GuideThantai",
            component: GuideThantai
        },
        {
            path: "/huong-dan/kienthiet",
            name: "GuideKT",
            component: GuideKT
        },
        {
            path: "/huong-dan/123",
            name: "Guide123",
            component: Guide123
        },
        {
            path: "/huong-dan/636",
            name: "Guide636",
            component: Guide636
        },
        {
            path: "/huong-dan/:id",
            name: "GuideContent",
            component: GuideContent
        },
        {
            path: "/auth/sign-up",
            name: "SignUp",
            component: SignUp
        },
        {
            path: "/vietlott",
            name: "Vietlott",
            component: KTMB,
            icon: faHome
        },
        {
            path: "/kienthiet",
            name: "Kiến Thiết",
            component: KienThiet,
            icon: faHome
        },
        {
            path: "/max3d_pro",
            name: "LotteryMax3D_Pro",
            component: LotteryMax3D_Pro
        },
        {
            path: "/234",
            name: "DT234",
            component: DT234
        },
        {
            path: "/235",
            name: "DT235",
            component: DT235
        },
        {
            path: "/6x36",
            name: "DT6x36",
            component: DT6x36
        },
        {
            path: "/than-tai",
            name: "DTThantai",
            component: DTThantai
        },
        {
            path: "/123",
            name: "DT123",
            component: DT123
        },
        {
            path: "/mega645",
            name: "LotteryMega645",
            component: LotteryMega645
        },
        {
            path: "/power655",
            name: "LotteryPower655",
            component: LotteryPower655
        },
        {
            path: "/max4d",
            name: "LotteryMax4D",
            component: LotteryMax4D
        },
        {
            path: "/max3d",
            name: "LotteryMax3D",
            component: LotteryMax3D
        },
        {
            path: "/max3d_plus",
            name: "LotteryMax3D_Plus",
            component: LotteryMax3D_Plus
        },
        {
            path: "/keno",
            name: "LotteryKeno",
            component: LotteryKeno
        },
        {
            path: "/kenobao",
            name: "LotteryKenoBao",
            component: LotteryKenoBao
        },
        {
            path: "/keno-chanle",
            name: "LotteryKenoCL",
            component: LotteryKenoCL
        },
        {
            path: "/cart",
            name: "Cart",
            component: Cart
        },
        {
            path: "/payment",
            name: "Payment",
            component: Payment
        },
        {
            path: "/payment-history/detail",
            name: "Payment Detail",
            component: PaymentDetail
        },
        {
            path: "/shopping-history/detail",
            name: "Shopping Detail",
            component: ShoppingDetail
        },
        {
            path: "/compare-result",
            name: "Compare result",
            component: CompareResult
        },
        {
            path: "/result",
            name: "Result",
            component: MainResult
        },
        {
            path: "/recharge",
            name: "Recharge",
            component: Recharge
        },
        {
            path: "/recharge-items",
            name: "Recharge Items",
            component: RechargeItems
        },
        {
            path: "/withdrawal",
            name: "Withdrawal",
            component: Withdrawal
        },
        {
            path: "/withdrawal-items",
            name: "Withdrawal Items",
            component: WithdrawalItems
        },
        {
            path: "/notifications",
            name: "Notifications",
            component: Notifications
        },
        {
            path: "/auth/otp",
            name: "OTP",
            component: OTP
        },
        {
            path: "/auth/forgot-password",
            name: "Forgot password",
            component: ForgotPassword
        },
        {
            path: "/vnpaypayment",
            name: "VNPAY",
            component: VNPAY_Return
        },
        {
            path: "/megapayment",
            name: "MEGA",
            component: MegaPay_Return
        },
        {
            path: "/momopayment",
            name: "Momo",
            component: Momo_Check
        },
        {
            path: "/ktmn",
            name: "Ktmn",
            component: KTMN,
        },
        
    ]
};

const dashboardRoutes = {
    path: "",
    name: "Dashboard",
    containsHome: true,
    children: [
        {
            path: "/",
            name: "Trang chủ",
            component: Home,
            icon: faHome
        },
        
        {
            path: "/shopping-history",
            name: "Lịch sử đặt vé",
            component: ShoppingHistory,
            icon: faStore
        },
        {
            path: "/payment-history",
            name: "Lịch sử giao dịch",
            component: PaymentHistory,
            icon: faMoneyBill
        },
        {
            path: "/result",
            name: "Kết quả",
            component: MainResult,
            icon: faTrophy
        },
        {
            path: "/analytics",
            name: "Thống kê bộ số",
            component: MainAnalytic,
            icon: faChartLine
        },
        {
            path: "/profile",
            name: "Thông tin tài khoản",
            component: Profile,
            icon: faUser
        },
        {
            path: "/contact",
            name: "Liên hệ",
            component: Help,
            icon: faPhone
        },
        {
            path: "/term",
            name: "Bảo mật và điều khoản",
            component: Term,
            icon: faLock
        },
       
    ]
};

const authRoutes = {
    path: "/auth",
    name: "Auth",
    children: [

    ]
};

const landingRoutes = {
    path: "",
    name: "Landing",
    children: [
        {
            // path: "/promotion/lucky-circle",
            // name: "Lucky Circle",
            // component: LuckyCircle
        }
    ]
};

const dashboardWithoutSidebarRoutes = {
    path: "",
    name: "Dashboard without sidebar",
    children: [
    ]
};

// Dashboard specific routes
export const dashboard = [
    dashboardRoutes,
    privacyRoutes
];

// Dashboard without sidebar
export const dashboardWithoutSidebar = [
    dashboardWithoutSidebarRoutes
];

// Landing specific routes
export const landing = [
    landingRoutes
];

// Auth specific routes
export const page = [authRoutes];

// All routes
export default [
    dashboardRoutes,
    authRoutes,
    landingRoutes,
    dashboardWithoutSidebarRoutes
];
